import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../contexts/AuthContext";
import { supabase } from "../../lib/supabase";
import { queryKeys } from "../../lib/queryKeys";
import { visibleCaptures } from "../mutations/useDismissCapture";
import { TaskCapture } from "../../types";

export async function fetchCaptures(): Promise<TaskCapture[]> {
  const { data, error } = await supabase
    .from("task_captures")
    .select("id, user_id, text, source, created_at")
    .order("created_at", { ascending: true });

  if (error) throw error;
  return (data ?? []) as TaskCapture[];
}

export function useCaptures() {
  const { user } = useAuth();

  return useQuery({
    queryKey: queryKeys.taskCaptures,
    queryFn: fetchCaptures,
    select: visibleCaptures,
    enabled: !!user,
  });
}
